import styled from 'styled-components';
import { brand } from 'themes/brand';
import EditIcon from '@mui/icons-material/Edit';

export const BaseEditIcon = styled(EditIcon)`
  color: ${brand.textSecondary};
  margin-right: 15px;

  :hover {
    cursor: pointer;
    color: ${brand.text};
  }
`;
